var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('ul', _vm._l((_vm.alphaList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.handleClick(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62980679","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectBoxIndex.vue
// module id = 7c+w
// module chunks = 1